var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var SvgProsperityPassportPoints = function SvgProsperityPassportPoints(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_3079_16959)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1524 0.836315C16.3462 0.648798 16.6538 0.648798 16.8476 0.836315L20.2798 4.15654C20.3906 4.26377 20.5447 4.31385 20.6974 4.29225L25.4256 3.62347C25.6927 3.5857 25.9415 3.76652 25.9881 4.03215L26.8132 8.73561C26.8398 8.88751 26.9351 9.01862 27.0713 9.0909L31.2896 11.329C31.5279 11.4554 31.6229 11.748 31.5045 11.9903L29.4073 16.2804C29.3396 16.419 29.3396 16.581 29.4073 16.7196L31.5045 21.0097C31.6229 21.252 31.5279 21.5446 31.2896 21.671L27.0713 23.9091C26.9351 23.9814 26.8398 24.1125 26.8132 24.2644L25.9881 28.9678C25.9415 29.2335 25.6927 29.4143 25.4256 29.3765L20.6974 28.7078C20.5447 28.6862 20.3906 28.7362 20.2798 28.8435L16.8476 32.1637C16.6538 32.3512 16.3462 32.3512 16.1524 32.1637L12.7202 28.8435C12.6094 28.7362 12.4553 28.6862 12.3026 28.7078L7.57437 29.3765C7.30733 29.4143 7.05846 29.2335 7.01186 28.9678L6.18681 24.2644C6.16017 24.1125 6.06491 23.9814 5.92868 23.9091L1.71038 21.671C1.47214 21.5446 1.37708 21.252 1.49552 21.0097L3.59266 16.7196C3.66039 16.581 3.66039 16.419 3.59266 16.2804L1.49552 11.9903C1.37708 11.748 1.47214 11.4554 1.71038 11.329L5.92868 9.0909C6.06491 9.01862 6.16017 8.88751 6.18681 8.73561L7.01186 4.03215C7.05846 3.76652 7.30733 3.5857 7.57437 3.62347L12.3026 4.29225C12.4553 4.31385 12.6094 4.26377 12.7202 4.15654L16.1524 0.836315Z",
    fill: "#476520"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_3079_16959)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8614 20C10.7807 20 10.7147 19.9743 10.6634 19.923C10.6121 19.8717 10.5864 19.8057 10.5864 19.725V12.575C10.5864 12.4943 10.6121 12.4283 10.6634 12.377C10.7147 12.3257 10.7807 12.3 10.8614 12.3H13.9414C14.5501 12.3 15.0781 12.3953 15.5254 12.586C15.9801 12.7693 16.3321 13.048 16.5814 13.422C16.8381 13.796 16.9664 14.269 16.9664 14.841C16.9664 15.4057 16.8381 15.8713 16.5814 16.238C16.3321 16.6047 15.9801 16.876 15.5254 17.052C15.0781 17.228 14.5501 17.316 13.9414 17.316H12.6324V19.725C12.6324 19.8057 12.6031 19.8717 12.5444 19.923C12.4931 19.9743 12.4271 20 12.3464 20H10.8614ZM12.5994 15.798H13.8864C14.2017 15.798 14.4511 15.7173 14.6344 15.556C14.8251 15.3947 14.9204 15.149 14.9204 14.819C14.9204 14.5403 14.8397 14.3057 14.6784 14.115C14.5171 13.9243 14.2531 13.829 13.8864 13.829H12.5994V15.798ZM18.295 20C18.2143 20 18.1483 19.9743 18.097 19.923C18.0457 19.8717 18.02 19.8057 18.02 19.725V12.575C18.02 12.4943 18.0457 12.4283 18.097 12.377C18.1483 12.3257 18.2143 12.3 18.295 12.3H21.375C21.9837 12.3 22.5117 12.3953 22.959 12.586C23.4137 12.7693 23.7657 13.048 24.015 13.422C24.2717 13.796 24.4 14.269 24.4 14.841C24.4 15.4057 24.2717 15.8713 24.015 16.238C23.7657 16.6047 23.4137 16.876 22.959 17.052C22.5117 17.228 21.9837 17.316 21.375 17.316H20.066V19.725C20.066 19.8057 20.0367 19.8717 19.978 19.923C19.9267 19.9743 19.8607 20 19.78 20H18.295ZM20.033 15.798H21.32C21.6353 15.798 21.8847 15.7173 22.068 15.556C22.2587 15.3947 22.354 15.149 22.354 14.819C22.354 14.5403 22.2733 14.3057 22.112 14.115C21.9507 13.9243 21.6867 13.829 21.32 13.829H20.033V15.798Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_3079_16959",
    x: 1.44482,
    y: 0.695312,
    width: 30.1104,
    height: 31.6094,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3079_16959"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3079_16959",
    x: 10.5864,
    y: 12.2998,
    width: 13.8135,
    height: 8.2002,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3079_16959"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_3079_16959",
    result: "shape"
  })))));
};
export default SvgProsperityPassportPoints;